/*
 * This is the main Ajax handling component for the entire project. It wraps all Ajax calls to and from the server 
 * expecting a common envelope format that it unpacks and passes back the enclosed data.
 */
(function ($) {
    // NOTE: Watch the use of .unique() which is required because of the use of 
    // compound selectors which could result in an element being matched multiple times

    // Sets an individual error on a form field
    /*$.fn.originFieldError = function(msg, errorSummary) {
    return this.each(function() {
    var id = $(this).attr('id') || '--no-id-specified--';
    var name = $(this).attr('name') || id;
    var selector = '.' + name + ',label[for=' + id + ']';
    // Add an error class to our input element and any associated labels
    // Need to use unique() since we're using a compound selector
    $(selector).unique().addClass('error');
    $(this).addClass('error');

    // Find any elements matching element name + Error and display our error message
    var fieldError = $('.' + name + 'Error,#' + name + 'Error').unique().eq(0);
    if ( fieldError.length == 1 ) {
    fieldError.addClass('fieldError').show().html( msg );
    } else {
    var summary = $( errorSummary ? errorSummary : '#originErrorSummary' );

    // See if an error container exists
    var ul = summary.find('div.ui-widget div.ui-state-error');
    if (!$(ul).length)
    {
    // If not create one
    ul = summary.prepend('<div class="ui-widget"><div class="ui-state-error"></div></div>');
    ul = ul.find('.ui-state-error');
    }

    var msgs = msg.split('<br />');
    $.each(msgs, function (index, msg) {
    ul.append('<p><span class="ui-icon ui-icon-alert"></span>' + msg + '</p>');
    });
    summary.show();
    }
    var _that = this;
    setTimeout(function() { $(_that).focus(); }, 75);
    });
    };*/

    $.fn.originShowErrors = function (errors, errorSummary) {
        var errorIcon = '<span class="ui-icon ui-icon-alert"></span>';
        $(this).each(function () {
            var fieldSection = $(errorSummary ? errorSummary : '#originErrorSummary');

            // If there wasn't a field summary passed in and there's no element with id="originErrorSummary" then default to the current context
            // fieldSection = fieldSection.length ? fieldSection : $(this);
            fieldSection = fieldSection.length ? fieldSection : $('body').first();

            // See if an error container exists, if not create one
            var errorBlock = fieldSection.find('div.ui-widget div.ui-state-error');
            if (!$(errorBlock).length) {
                errorBlock = fieldSection
								.prepend('<div class="ui-widget"><div class="ui-state-error"></div></div>')
								.find('.ui-state-error');
            }

            // Clear previous errors and error formatting on input fields
            $(this).find('div.input').removeClass('error');
            errorBlock.empty().hide();

            // Show general error message if present
            if (errors.message && errors.message.length > 0) {
                errorBlock.append('<p>' + errorIcon + errors.message.join('</p><p>' + errorIcon) + '</p>');
            }

            var first = '';
            var _this = this;
            $.each(errors.element || {}, function (element, msg) {
                element = element.replace(',', ',#');

                // Save first element so we can set focus to it later
                if (first == '') {
                    first = element;
                }

                // Find the element that has the error and highlight it
                $(_this).find('#' + element + ',:input[name=' + element + ']').unique().parents('div').first().addClass('error');

                // Add the error messages to the error block
                var msgs = msg.split('<br />');
                $.each(msgs, function (index, msg) {
                    errorBlock.append('<p>' + errorIcon + msg + '</p>');
                });
            });

            // If any errors were found, show the error block
            if (errorBlock.find('p').length > 0) {

                // Focus the first field with an error
                if (first != '') {
                    $(_this).find('#' + first + ',:input[name=' + first + ']').unique().eq(0).focus();
                }

                errorBlock.show();

                // Find the first overflowed and scrolled down
                errorBlock.parents().each(function () {
                    // Scrolling a parent of the dialog's container would cause the dialog to jump down
                    if ($(this).attr('role') == 'dialog') {
                        return false;
                    }
                    if ($(this).scrollTop() > 0) {
                        $(this).scrollTop(errorBlock.position().top);
                        return false;
                    }
                });

                $('.ui-dialog-content').scrollTop(errorBlock.scrollTop());
            }
        });
        return this;
    };


    $.fn.originClearErrors = function (errorSummary) {
        return this.each(function () {
            $('.input.error', this).unique().removeClass('error');
            //$('.fieldError', this).html('').hide();
            $(errorSummary ? errorSummary : '#originErrorSummary').find('div.ui-widget div.ui-state-error').remove();
        });
    };

    

    Origin.checkAuthentication = function(XMLHttpRequest) {

        var authCookieExists = Origin.cookieExists('SgFedAuth');
        if (!authCookieExists) {
            var location = window.location.href;
            $.ajax({
                url: "/Account/RenewClaim",
                cache: false,
                type: 'GET',
                async: false,
                beforeSend: null,
                success: function (result, textStatus, xhr) {

                    // TODO: At some point possibly add a response header to the response in case we want to do something special here.
                    //if (xhr.getResponseHeader('REQUIRES_AUTH') === '1') {
                    //    XMLHttpRequest.abort();
                    //    window.location = location;
                    //}
                }
            });
        }
    };

    //$.ajaxSetup({
    //    beforeSend: Origin.checkAuthentication
    //});
    
    // Global Ajax request handler
    // Use this method if you already have your data collected from the form
    $.fn.originAjax = function (options) {
        var ajaxOptions = $.extend({
            // Default values (overwriteable)
            async: true,
            cache: false,
            dataType: 'json',
            global: true,
            type: 'POST',
            target: this[0]
        },
        // Optional user options
			options.ajax || {},
        // Define our callbacks after options.ajax so they aren't overwritten
			{
			url: options.url,
			data: options.data || {},
			errorSummary: options.errorSummary || '#originErrorSummary',
			error: function (xhr, status, error) {
			    // status: null, timeout, error, nomodified, parsererror
			    var err = {
			        message: ['Request Error(' + status + ') ' + error],
			        responseText: xhr.responseText,
			        responseStatus: xhr.status,
			        headers: xhr.getAllResponseHeaders(),
                    ajaxStatus: status
			    };

				if (xhr.status == 0) {
					console.log('Origin Ajax Cancel:');
					console.log(JSON.stringify({ xhr: xhr, status: status, error: error, err: err, this: this }));
					return;
				}

			    console.log('Origin Ajax Error:');
			    console.log(err);

			    if (error == INVALID_REQUEST_KEY) {
			        Origin.redirect(SESSION_TIMEOUT_URL);
			        return;
			    }

			    $(this.target && xhr.statusText !== "abort")
					.originShowErrors(err, this.errorSummary)
					.trigger('originAjaxFail', [err]);
			    if ($.isFunction(options.fail)) {
			        options.fail.call(this.target, err);
			    }

			    if ($.isFunction(options.error)) {
			        options.error.call(this.target, err);
			    }
			},
			success: function (json) {
			    $(this.target).originClearErrors();
			    // JsonEnvelope response
			    if (json.status == 'success') {
			        if ($.isFunction(options.success)) {
			            if (options.success.call(this.target, json.data) === false) {
			                return;
			            }
			        }
			        $(this.target).trigger('originAjaxSuccess', [json.data]);
			    } else {
			        if (json.data == 'INVALIDREQUESTKEY') { //SESSION TIMEOUT, just redirect to session timeout page.
			            Origin.redirect(SESSION_TIMEOUT_URL);
			            return;
			        }

			        if (json.data == 'EXPIREDTRIALREDIRECT') { // Trial has expired, redirect 
			            Origin.redirect('/Account/ExpiredTrialRedirect');
			            return;
			        }

			        if ($.isFunction(options.error)) {
			            if (options.error.call(this.target, json.data) === false) {
			                return;
			            }
			        }
			        $(this.target)
						.originShowErrors(json.data, this.errorSummary)
						.trigger('originAjaxError', [json.data]);
			    }
			},
			complete: function () {
			    if ($.isFunction(options.finished)) {
			        options.finished.call(this.target);
			    }
			}
});

        // Check for a before handler
        if ($.isFunction(options.before)) {
            if (options.before.call(this.target) === false) {
                console.log('Ajax request cancelled');
                return this;
            }
        }

        // Execute the Ajax request
        $.ajax(ajaxOptions);
        return this;
    };

    // Global AjaxForm submit handler, gather's form input elements
    /*
    // Settings options
    $(...).originAjaxForm({
    url: '/url/to/service',
    fields: 'field selector',
    data: {
    'name' : '#selector',
    'name' :	function() {
    return 'Special field value';
    }
    },
    success: function(json) {
    }
    });

    // Shorthand to handle json response
    $('#myForm').originAjaxForm(function(json) {
    // Process your json data
    });

    // Expanded option to handle json response
    $('#myForm').originAjaxForm({
    error: function(json) {
    json.message = []
    },
		
    success: function(json) {
    }
    });

    // Handle json response by event
    $('#myForm')
    .originAjaxForm()
    .bind('originAjaxSuccess', function(evt, json) {
    // Process your json data
    });
    */
    // Use this method if you have a form element and want the data (input) elements collected for you
    $.fn.originAjaxForm = function (options) {
        return this.each(function () {
            if ($.isFunction(options)) {
                options = { success: options };
            }

            $(this)
				.data('options', options)
				.bind('reset', function (evt) {
				    $(this)
						.originClearErrors()
						.trigger('originClearErrors');
				    $('input[type=text],textarea,input[type=passwrd]', this).val('');
				    $(':checkbox,:radio', this).attr('checked', false);
				    // Stop the default reset event
				    return false;
				})
            // Form submit event
				.bind('submit', function (evt) {
				    evt.preventDefault();
				    evt.stopPropagation();

				    // Clear any errors on our form
				    $(this)
						.originClearErrors()
						.trigger('originClearErrors');

				    var options = $(this).data('options');

				    // We need to grab our url from the form right before submit (now)
				    // in case it was modified after page load
				    var ajaxOptions = $.extend({
				        url: $(this).attr('action')
				    }, options);

				    // Setup our data object and populate it with the form fields
				    var fields;
				    if (options.fields) {
				        fields = $(options.fields);
				    } else {
				        fields = $(':input', this).not('[type=submit]');
				    }
				    ajaxOptions.data = fields.getFormFields(options.data || []);

				    // Execute the ajax request
				    $(this).originAjax(ajaxOptions);

				    // Return false preventing default form submission
				    return false;
				});
        });
    };

    Origin.ajax = function (requestOptions) {
        $(document).originAjax(requestOptions);
    };
})(jQuery);